import { render, staticRenderFns } from "./ChairMenu.vue?vue&type=template&id=7b5dcfba"
import script from "./ChairMenu.vue?vue&type=script&lang=ts"
export * from "./ChairMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports